import React from 'react';
import { Link } from 'react-router-dom';
import { FUEL_URL } from './effyFuelContent';

// Closing call-to-action shared by the two Effy Fuel pages. Reuses the Effy Order CTA styles.
export function FuelCta() {
  return (
    <section className="oi-pricing-cta">
      <div className="oi-pricing-cta__inner">
        <h2 className="oi-pricing-cta__title">Ready to close shifts the easy way?</h2>
        <p className="oi-pricing-cta__subtitle">
          Sign up in a minute and enter your first shift today. Have a question first? We are happy to help.
        </p>
        <div className="seo-cta__actions">
          <a href={`${FUEL_URL}/signup`} className="btn-v2 btn-v2--primary">Try it free</a>
          <Link to="/contact" className="btn-v2 btn-v2--secondary">Get in touch</Link>
        </div>
      </div>
    </section>
  );
}
